export const API_BASE_URL = 'https://stickyquips.herokuapp.com';

export const NOTES_API_URL = `${API_BASE_URL}/notes`;
